import { render, staticRenderFns } from "./billManager.vue?vue&type=template&id=0282f1b9&scoped=true&"
import script from "./billManager.vue?vue&type=script&lang=js&"
export * from "./billManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282f1b9",
  null
  
)

export default component.exports